import React from 'react';

const Settings: React.FC = () => {
  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Settings</h3>
      <p style={{ color: 'var(--color-text-muted)' }}>Profile, organization, and preferences coming soon.</p>
    </div>
  );
};

export default Settings; 